const subsections = [
  {
    id: "buy-before",
    label: "¿Has comprado fibra de carbono antes?",
    type: "radio",
    options: ["Sí", "No"],
  },
  {
    id: "work-fiber",
    label: "¿Trabajas tiempo completo con fibra de carbono?",
    type: "radio",
    options: ["Sí", "No"],
  },
  {
    id: "work-type",
    label:
      "¿Cómo trabajas con la fibra de carbono? (selecciona todo lo que aplique)",
    type: "checkbox",
    options: [
      "Producción / Fabriación",
      "Reparación",
      "Forrado / Estética",
      "No la he usado",
    ],
  },
  {
    id: "sector",
    label: "¿En qué sector utilizas la fibra de carbono?",
    type: "checkbox",
    options: ["Automotriz / Motociclismo", "Industrial", "Otros"],
  },
];

const Step2Form = ({ data, onChange }) => {
  const handleCheckboxChange = (sectionId, option, checked) => {
    onChange(sectionId, {
      ...data[sectionId],
      [option]: checked,
    });
  };

  const handleRadioChange = (sectionId, option) => {
    onChange(sectionId, option);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-6 p-4 rounded-lg text-left bg-primary-green">
        {subsections.map((section) => (
          <div key={section.id} className="flex flex-col gap-2">
            <h3 className="text-white font-bold text-sm sm:text-base mb-1">
              {section.label}
            </h3>

            {section.type === "checkbox" &&
              section.options.map((option) => (
                <label
                  key={option}
                  className="flex items-center gap-3 text-white text-sm cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={!!data[section.id]?.[option]}
                    onChange={(e) =>
                      handleCheckboxChange(section.id, option, e.target.checked)
                    }
                    className="w-4 h-4 rounded border-gray-300 accent-black"
                  />
                  {option}
                </label>
              ))}

            {section.type === "radio" &&
              section.options.map((option) => (
                <label
                  key={option}
                  className="flex items-center gap-3 text-white text-sm cursor-pointer"
                >
                  <input
                    type="radio"
                    name={section.id}
                    value={option}
                    checked={data[section.id] === option}
                    onChange={() => handleRadioChange(section.id, option)}
                    className="w-4 h-4 border-gray-300 accent-black"
                  />
                  {option}
                </label>
              ))}
          </div>
        ))}
      </div>
      <p className="text-white text-xs md:text-xl md:text-left text-center">
        Con esta información podremos brindarte acceso a la plataforma.
      </p>
    </div>
  );
};

export default Step2Form;
